import * as http from '../../modules/http';
import * as UrlParamsManager from '../../modules/UrlParamsManager';

export const AUTO_CUSTOMERS_REQUEST_START = 'AUTO_CUSTOMERS_REQUEST_START';
export const AUTO_CUSTOMERS_REQUEST_SUCCESS = 'AUTO_CUSTOMERS_REQUEST_SUCCESS';
export const AUTO_CUSTOMERS_REQUEST_FAILED = 'AUTO_CUSTOMERS_REQUEST_FAILED';
export const AUTO_CUSTOMERS_REQUEST_NO_PERMISSION = 'AUTO_CUSTOMERS_REQUEST_NO_PERMISSION';
export const AUTO_CUSTOMERS_OPEN_UPDATE_FORM = 'AUTO_CUSTOMERS_OPEN_UPDATE_FORM';
export const AUTO_CUSTOMERS_DELETE = 'AUTO_CUSTOMERS_DELETE';
export const AUTO_CUSTOMERS_UPDATE = 'AUTO_CUSTOMERS_UPDATE';
export const AUTO_CUSTOMER_INSERT = 'AUTO_CUSTOMER_INSERT';
export const AUTO_CUSTOMER_UPDATE = 'AUTO_CUSTOMER_UPDATE';

export function auto_customers_request_start(country,date,product,platform) {
    return {
        type: AUTO_CUSTOMERS_REQUEST_START,
        country:country,
        date:date,
        product:product,
        platform:platform
    };
}

export function auto_customers_request_success(data) {
    return {
        type: AUTO_CUSTOMERS_REQUEST_SUCCESS,
        data:data
    };
}

export function auto_customers_request_failed() {
    return {
        type: AUTO_CUSTOMERS_REQUEST_FAILED
    };
}

export function auto_customers_request_no_permission() {
    return {
        type: AUTO_CUSTOMERS_REQUEST_NO_PERMISSION
    };
}

export function auto_customers_open_update_form(customer) {
    return {
        type: AUTO_CUSTOMERS_OPEN_UPDATE_FORM,
        customer:customer
    };
}

/*export function customers_update(data) {
    return {
        type: CUSTOMERS_UPDATE,
        data:data
    };
}*/

export function auto_customers_delete(id) {
    return {
        type: AUTO_CUSTOMERS_DELETE,
        id:id
    };
}
export function auto_customer_insert(customer) {
    return {
        type: AUTO_CUSTOMER_INSERT,
        customer: customer
    };
}

/*export function customer_update(customer, index) {
    return {
        type: CUSTOMER_UPDATE,
        customer: customer,
        index: index
    };
}*/

export function auto_customer_update(customer) {
    return {
        type: AUTO_CUSTOMER_UPDATE,
        customer: customer
    };
}

//
//
//Async Actions
//
//
export function fetchAutoCustomeraDataIfNeeded(queryParams) {
    var date = UrlParamsManager.getDate(queryParams);
    var provider = UrlParamsManager.getProvider(queryParams);
    var status = UrlParamsManager.getStatus(queryParams);
    var secondStatus = UrlParamsManager.getSecondStatus(queryParams);
    var store = UrlParamsManager.getStore(queryParams);
    var dealtype = UrlParamsManager.getDealType(queryParams);
    var isNew = UrlParamsManager.getIsNew(queryParams);
    var duplicate = UrlParamsManager.getDuplicate(queryParams);

    return (dispatch, getState) => {
        if (shouldFetchAutoCustomersData(getState(),date,provider,status,secondStatus,store,dealtype,isNew,duplicate)) {
            return dispatch(fetchAutoCustomersData(date,provider,status,secondStatus,store,dealtype,isNew,duplicate));
        }
    };
}

function shouldFetchAutoCustomersData(state,date,provider,status,secondStatus,store,dealtype,isNew,duplicate) {
    if (!state.autoCustomers.data){
        return true;
    }
    else if (state.autoCustomers.date !== date ||
        state.autoCustomers.provider !== provider ||
        state.autoCustomers.status !== status ||
        state.autoCustomers.secondStatus !== secondStatus ||
        state.autoCustomers.store !== store ||
        state.autoCustomers.dealtype !== dealtype ||
        state.autoCustomers.isNew !== isNew ||
        state.autoCustomers.duplicate !== duplicate) {
        return true;
    }
    else{
        return false;
    }
}


function fetchAutoCustomersData(date,provider,status,secondStatus,store,dealtype,isNew,duplicate) {
    var dateFilter = {
        filter:true,
        platform:'',
        value:date.date,
        range:{startDate:date.startDate,endDate:date.endDate}
    };

    var requestParams = {
        date:dateFilter,
        //provider:parseInt(provider),
        provider:provider,
        status:status, //parseInt(status),
        secondStatus:secondStatus, //parseInt(secondStatus),
        store:store,
        dealtype:dealtype, //parseInt(dealtype)
        isNew: isNew,
        duplicate:duplicate
    };

    return ((dispatch) => {
        dispatch(auto_customers_request_start(provider,status,secondStatus,store,dealtype,isNew,duplicate));

        let request = 'auto_customers/get';

        http.postToServer(request,
            requestParams,
            (response) =>  {dispatch(auto_customers_request_success(response.data))},
            (response) =>  {dispatch(auto_customers_request_failed())},
            (response) =>  {dispatch(auto_customers_request_no_permission())}

        );

    });
}
